var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.active,"collapse":_vm.collapse,"text-color":"#666666","unique-opened":true,"router":"","collapse-transition":false},on:{"open":_vm.handleOpen,"close":_vm.handleClose}},_vm._l((_vm.menuList),function(menu){return _c('sidebar-item',{key:menu.path,attrs:{"item":menu}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }